<template>

  <div v-if="recipes.length==0">

    {{$t('library.no_cycles')}}

  </div>

  <div v-else class="library">
    
    <div class="irinox-form">
      <div class="p-grid p-nogutter">
        <div class="p-col">
          <div class="p-formgroup-inline p-ai-center">
            <div class="p-field">
              <Dropdown v-model="filter.config" :options="filters.configs" optionLabel="name" optionValue="code"
                :placeholder="$t('library.filter_package_ph')" />
            </div>
            <div class="p-field">
              <Dropdown v-model="filter.sector" :options="filters.sectors" optionLabel="name" optionValue="code"
                :placeholder="$t('library.filter_sector_ph')" />
            </div>
            <div class="p-field">
              <Dropdown v-model="filter.function" :options="filters.functions" optionLabel="name" optionValue="code"
                :placeholder="$t('library.filter_function_ph')" />
            </div>
            <div class="p-field">
              <Dropdown v-model="filter.type" :options="filters.types" optionLabel="name" optionValue="code"
                :placeholder="$t('library.filter_type_ph')" />
            </div>
          </div>
        </div>
        <div class="p-col-fixed search-bar" style="width: fit-content">
          <i class="pi pi-search" />
          <InputText v-model="filter.text" :placeholder="$t('library.search')" :aria-label="$t('library.search')"/>
          <i class="pi pi-times" @click="() => {filter.text = null}"/>
        </div>
      </div>
    </div>

    <DataView :value="recipesFiltered" :layout="'grid'" :rows="12" 
        :paginator="true" paginatorTemplate="PrevPageLink CurrentPageReport NextPageLink"
        currentPageReportTemplate="{currentPage} / {totalPages}"
        sortField="name" :sortOrder="1"
        style="margin: 0 -1rem">

      <template #empty>
        <div class="p-m-4">{{$t('library.no_cycles_filtered')}}</div>
      </template>

      <template #grid="slotProps">
          <div class="p-col-12 p-sm-12 p-md-6 p-lg-4 p-xl-3" >
            <div class="card p-m-2 p-p-0 recipe-card p-d-flex p-jc-between clickable" @click="openRecipe(slotProps.data.id)">

              <div class="p-d-flex p-jc-between p-flex-column left-column" >
                <div class="p-d-flex p-ai-center p-jc-center p-flex-column p-pt-2">
                  <span :class="'icon-mf_function_'+(slotProps.data.function).toString().padStart(2, '0')" style="font-size: 30px;"/>
                  <span style="font-size: 0.8rem;">{{$functions.temperature(slotProps.data.temperature, isCelsius, 1)}} {{unit}}</span>
                </div>
                <div class="p-d-flex p-ai-center p-jc-center p-p-2 sectors" :set="localSectors = getSectors(slotProps.data.sector)">
                  <span v-if="localSectors.length==1" :class="'icon-sector_'+localSectors[0]" style="font-size: 25px;"></span>
                  <div v-else class="multiple-sectors p-grid p-jc-center p-ai-center">
                    <div v-for="sector in localSectors" :key="slotProps.data.id + '_' + sector" class="p-col-6 p-p-0">
                      <span :class="'icon-sector_'+sector" style="font-size: 15px;"/>
                    </div>
                  </div>
                </div>
              </div>

              <div class="p-d-flex p-mt-4 p-ai-center p-flex-column center-column p-jc-between">
                <div class="p-d-flex p-ai-center p-flex-column center-column">
                  <div>
                    <span :class="'icon-mf_cycle_image_'+(slotProps.data.image).toString().padStart(4, '0')" style="font-size: 55px;"/>
                  </div>
                  <div class="p-text-center p-mt-1">
                    {{slotProps.data.name}}
                  </div>
                </div>
                <div v-if="slotProps.data.energy" class="p-d-flex p-ai-center p-jc-center p-pb-2" v-tooltip.bottom="$t('energy.estimated_consumption_tooltip')">
                  <img src="assets/irinox/icons/energy_green_small.png" style="width: 18px;" alt="Energy" class="p-mr-1"/>
                  <span :class="['green']" style="font-size: 0.8rem;">{{slotProps.data.energy ? $n(slotProps.data.energy)+' kWh' : ''}}</span>
                  <img src="assets/irinox/icons/ai_info.svg" alt="Irinox AI powered"/> 
                </div>
              </div>

              <div class="p-d-flex p-jc-between p-flex-column right-column" >
                <div class="p-d-flex p-ai-center p-jc-end">
                  <img v-if="slotProps.data.package===1 || slotProps.data.package===7 || slotProps.data.package===8" :src="'assets/irinox/cycles/mf_package_'+slotProps.data.package+'.svg'" :alt="$t('library.filter_package_ph')"/>
                </div>
                <div class="p-d-flex p-ai-center p-jc-center p-pb-2 p-pr-2">
                  <img v-if="slotProps.data.type===0 || slotProps.data.type===1" :src="'assets/irinox/cycles/mf_type_'+slotProps.data.type+'.svg'" width="55" :alt="$t('library.filter_type_ph')"/>
                </div>
              </div>

            </div>
          </div>
      </template>

    </DataView>


  </div>

</template>

<script>
import RecipeService from '../../service/RecipeService';
import { mapGetters } from 'vuex';

export default {

  components: {
    },
    props: {
      serialNumber: String,
      appliance: Object
    },
    data() {
        return {
          filters: {
            configs: [{
                code: null,
                name: this.$t('library.filter_remove') 
              },{
                code: 1, // Matcha solo package ricetta 1
                name: this.$t('mf.packages.1') 
              },{
                code: 7, // Matcha package ricetta 1, 7 e 8
                name: this.$t('mf.packages.7') 
              }],
              sectors: [{
                code: null,
                name: this.$t('library.filter_remove') 
              },{
                code: 3,
                name: this.$t('mf.sectors.gastronomy') 
              },{
                code: 2,
                name: this.$t('mf.sectors.pastry') 
              },{
                code: 1,
                name: this.$t('mf.sectors.bakery') 
              },{
                code: 0,
                name: this.$t('mf.sectors.icecream') 
              }],
            functions: [{
                code: null,
                name: this.$t('library.filter_remove') 
              }],
            types: [{
                code: null,
                name: this.$t('library.filter_remove') 
              },{
                code: 0,
                name: this.$t('mf.types.0') 
              },{
                code: 1,
                name: this.$t('mf.types.1') 
              }]
          },
          filter: {
            config: null,
            sector: null,
            function: null,
            type: null,
            text: null
          },
          recipes: [],
          recipesFiltered: [],
          dialog: {
            error: false,
          },
        };
    },
    computed: {
      ...mapGetters({
          personaltoken: 'userdata/personaltoken',
          unit: 'userdata/unit',
          isCelsius: 'userdata/isCelsius',
        }),
    },
    watch: {
      "recipes": 'filterRecipes',
      "filter.config": 'filterRecipes',
      "filter.sector": 'filterRecipes',
      "filter.function": 'filterRecipes',
      "filter.type": 'filterRecipes',
      "filter.text": 'filterRecipes',
    },
    created() {
      this.recipeService = new RecipeService();
      for(let i=0; i<16; i++) {
        this.filters.functions[i+1] = {
          code: i,
          name: this.$t('mf.functions.'+i) 
        };
      }
    },
    mounted() {
      this.reloadRecipes();
    },
    methods: {
      reloadRecipes() {
        if(this.serialNumber) {
          this.recipeService.getRecipesByAppliance(this.personaltoken, this.serialNumber)
            .then((data) => {
              this.recipes = data.body;

              //Macchina excellence (pkg 5) --> Marinatura (15) solo se firmware >= v7.7
              const marinaturaThreshold = "v7.7";
              const fw = this.appliance?.currentSoftwareVersion ?? null;
              
              const marinaturaEnabled = fw !== null
                ? this.$functions.compareVersionStrings(fw, marinaturaThreshold) >= 0
                : false; // Conservativo se firmware sconosciuto

              if(this.appliance._package!=6 && !marinaturaEnabled) {
                //Se la macchina non supporta la funzione di marinatura, filtro le ricette che la prevedono per evitare confusione all'utente
                this.recipes = this.recipes.filter(recipe => recipe.function !== 15);
              }
            })
            .catch(error => {
              console.error("ERROR "+error);
              this.recipes = [];
              this.dialog.error = true;
            });
        } else {
          this.recipeService.getRecipesForUser(this.personaltoken)
            .then((data) => {
              this.recipes = data.body;
            })
            .catch(error => {
              console.error("ERROR "+error);
              this.recipes = [];
              this.dialog.error = true;
            });
        }
      },
      filterRecipes() {
        this.recipesFiltered = this.recipes.filter(function(val) {
              let configStatus = this.filter.config!=null ? this.matchConfig(val.package, this.filter.config) : true;
              let functionStatus = this.filter.function!=null ? val.function == this.filter.function : true;
              let typeStatus = this.filter.type!=null ? val.type == this.filter.type : true;
              let sectorStatus = this.filter.sector!=null ? this.matchSector(val.sector, this.filter.sector) : true;
              let textStatus = this.filter.text ? val.name.toLowerCase().includes(this.filter.text.toLowerCase())  : true;
              return configStatus && functionStatus && typeStatus && sectorStatus && textStatus;
            }.bind(this))
      },
      matchConfig(config, filter) {
        return (filter === 7 && (config === 1 || config === 7 || config === 8)) || (filter === 1 && config === 1)
      },
      matchSector(sector, filter) {
        let binaryNum = sector.toString(2);
        binaryNum = "0000".substr(binaryNum.length) + binaryNum;
        return binaryNum.charAt(filter)==='1';
      },
      getSectors(sector) {
        if(!sector) {
          sector = 0;
        }
        let binaryNum = sector.toString(2);
        binaryNum = "0000".substr(binaryNum.length) + binaryNum;
        let sectorList = [];
        if(binaryNum.charAt(3)==='1') sectorList.push("gastronomy");
        if(binaryNum.charAt(2)==='1') sectorList.push("pastry");
        if(binaryNum.charAt(1)==='1') sectorList.push("bakery");
        if(binaryNum.charAt(0)==='1') sectorList.push("icecream");
        return sectorList;
      },
      openRecipe(recipeId) {
        if(this.serialNumber) {
          this.$router.push({ name: 'appliance-recipe-overview', params: { serialNumber: this.serialNumber, recipeId: recipeId }});
        } else {
          this.$router.push({ name: 'recipe-overview', params: { recipeId: recipeId }});
        }
      }
    }

}
</script>

<style scoped>
.irinox-form .p-dropdown {
    width: 200px;
}

</style>